var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRectangleHorizontalThin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    viewBox: "0 7 24 8",
    className: "svg-icon",
    style: {
      height: 8
    },
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 9v6H2V9h20zm-2 2H4v2h16v-2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRectangleHorizontalThin);
export default __webpack_public_path__ + "static/media/rectangle-horizontal-thin.362de860cb1698f49daa8a317497b16f.svg";
export { ForwardRef as ReactComponent };